import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Modal } from "react-bootstrap";
import { FaSearch, FaPlayCircle, FaYoutube } from "react-icons/fa";
import styled from 'styled-components';

const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  cursor: pointer;
  
  &:hover {
    opacity: 1;
  }
`;

const PlayIcon = styled(FaPlayCircle)`
  font-size: 4rem;
  color: white;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.1);
  }
`;

const VideoModal = styled(Modal)`
  .modal-dialog {
    max-width: 900px;
    margin: 2rem auto;
  }
  
  .modal-content {
    border: none;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    
    @media (max-width: 768px) {
      border-radius: 10px;
    }
  }
  
  .modal-header {
    border-bottom: none;
    padding: 1.5rem;
    
    h5 {
      font-weight: 600;
      color: #2c3e50;
      margin: 0;
      display: flex;
      align-items: center;
      
      svg {
        margin-right: 10px;
        color: #ff4d4f;
      }
    }
    
    .close {
      opacity: 0.7;
      font-size: 1.25rem;
      padding: 0.5rem;
      
      &:hover {
        opacity: 1;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 50%;
      }
    }
  }
  
  .modal-body {
    padding: 0;
  }
`;

const ModalVideoContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  border-radius: 0 0 20px 20px;
  background: #ffffff;
  
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
  
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, rgba(255, 77, 79, 0.05) 0%, rgba(255, 77, 79, 0.1) 100%);
    pointer-events: none;
  }
`;

const VideoCard = styled(Card)`
  transition: all 0.3s ease;
  border: none;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 2rem;
  height: 100%;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
  
  .card-body {
    padding: 1.5rem;
  }
  
  .card-title {
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 0.75rem;
    display: flex;
    align-items: center;
    
    svg {
      margin-right: 10px;
      color: #ff4d4f;
    }
  }
  
  .card-text {
    color: #6c757d;
    font-size: 0.95rem;
    margin-bottom: 1rem;
  }
  
  .video-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    border-radius: 8px;
    background: #f8f9fa;
    
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
`;

const SearchBar = styled.div`
  max-width: 600px;
  margin: 2rem auto 3rem;
  
  .search-input {
    border-radius: 25px;
    padding: 0.75rem 1.5rem 0.75rem 1.5rem;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    padding-left: 1.5rem;
    
    &:focus {
      border-color: #1890ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
  }
  
  .search-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #9e9e9e;
    pointer-events: none;
  }
`;

const PageHeader = styled.div`
  text-align: center;
  margin: 3rem 0 1.5rem;
  
  h1 {
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 0.5rem;
  }
  
  p {
    color: #6c757d;
    font-size: 1.1rem;
    max-width: 700px;
    margin: 0 auto;
  }
`;

const videos = [
  { 
    id: "9wT2ERN6MfI", 
    title: "BBR BASS BOAT RENTALS EXPLAINER",
    description: "Learn how BBR Bass Boat Rentals platform works and how you can benefit from it."
  },
  { 
    id: "NUW38hDdFWY", 
    title: "HOW TO LIST YOUR BOAT",
    description: "Step-by-step guide on listing your boat for rent on our platform."
  },
  { 
    id: "0BfRYaAxbX0", 
    title: "HOW TO LIST A KAYAK FOR RENT",
    description: "Tutorial on how to list your kayak for rent and start earning."
  },
  { 
    id: "YrnQcwhvM4w", 
    title: "HOW TO MAKE A BOOKING INQUIRY",
    description: "Learn how to send an inquiry for a listing you wish to rent."
  },
  { 
    id: "0FM4lapC0Ko", 
    title: "HOW TO RENT A BASS BOAT",
    description: "Complete guide on renting a bass boat through our platform."
  },
  { 
    id: "oYwk7kCwg-M", 
    title: "HOW TO RENT A JET SKI",
    description: "Step-by-step instructions for renting a jet ski."
  },
  { 
    id: "0BfRYaAxbX0", 
    title: "HOW TO RENT A KAYAK",
    description: "Learn how to easily rent a kayak for your next adventure."
  },
  { 
    id: "bVm_9nnRsJg", 
    title: "HOW TO START A TRIP FROM YOUR DASHBOARD",
    description: "Guide on how to start and manage your rental trips."
  },
  { 
    id: "o2HDLeZsDbY", 
    title: "HOW TO ADVERTISE YOUR BOAT LISTING",
    description: "Tips and tricks to make your boat listing stand out."
  },
  { 
    id: "bwHvnYlpAZE", 
    title: "HOW TO GET VERIFIED",
    description: "Complete the verification process to unlock all platform features."
  },
];

function YouTubeEmbed({ video }) {
  return (
    <iframe
      className="how-to-videos w-full"
      src={`https://www.youtube.com/embed/${video.id}`}
      title={video.title}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      // Remove the style prop to let CSS handle the sizing
    ></iframe>
  );
}

export default function How() {
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  
  const filteredVideos = videos.filter(video => 
    video.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    video.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleVideoClick = (video) => {
    setSelectedVideo(video);
    setShowModal(true);
  };

  return (
    <Container className="py-4">
      <PageHeader>
        <h1>How It Works</h1>
        <p>Watch our tutorial videos to get the most out of BBR Bass Boat Rentals</p>
      </PageHeader>
      
      <SearchBar>
        <div className="position-relative">
          <Form.Control
            type="text"
            placeholder="Search tutorials..."
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <FaSearch className="search-icon" />
        </div>
      </SearchBar>
      
      <Row className="g-4">
        {filteredVideos.map((video, index) => (
          <Col key={index} lg={6} xl={4}>
            <VideoCard>
              <Card.Body>
                <Card.Title>
                  <FaYoutube size={20} />
                  {video.title}
                </Card.Title>
                <Card.Text>{video.description}</Card.Text>
                <div className="video-container" onClick={() => handleVideoClick(video)}>
                  <YouTubeEmbed video={video} />
                  <VideoOverlay>
                    <PlayIcon />
                  </VideoOverlay>
                </div>
              </Card.Body>
            </VideoCard>
          </Col>
        ))}
      </Row>
      
      <VideoModal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton style={{ padding: '15px 15px 0px 15px' }}>
          <Modal.Title >
            <FaYoutube size={20} style={{ marginRight: '10px' }} />
            {selectedVideo?.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card.Body>
            {/* <Card.Text>{selectedVideo?.description}</Card.Text> */}
            <ModalVideoContainer>
              <YouTubeEmbed video={selectedVideo} />
            </ModalVideoContainer>
          </Card.Body>
        </Modal.Body>
      </VideoModal>
      
      {filteredVideos.length === 0 && (
        <div className="text-center py-5">
          <FaSearch size={48} className="text-muted mb-3" />
          <h4>No tutorials found</h4>
          <p className="text-muted">Try adjusting your search or check back later for more tutorials.</p>
        </div>
      )}
    </Container>
  );
}
